import type { QuestionValues } from '@webapp/common/resources/question';
import type { AnswerType } from '@webapp/common/resources/survey';

export interface QuestionRow extends QuestionValues {
    exception?: boolean;
    fileId: string;
    filePath: string;
    height: number;
    id: number;
    isNew?: boolean;
    isExpanded?: boolean; // For KANO rows - whether the row is expanded in editor
    mimeType: string;
    order?: number;
    text?: string;
    textBlock?: string;
    type?: AnswerType;
    videoLink?: string;
    pinned: boolean;
    excluded: boolean;
    width: number;
    forwardParent: number | null;
    answerArea?: {
        id: number;
        answerId: number;
        x: number;
        y: number;
        width: number;
        height: number;
        isDefault: boolean;
    };
}

export const initialRow: Readonly<QuestionRow> = {
    id: 0,

    value: '',
    value2: '',
    value3: '',

    type: null,
    exception: false,
    order: 0,

    fileId: null,
    filePath: null,
    width: 0,
    height: 0,
    mimeType: null,

    text: null,
    forwardParent: null,
    pinned: false,
    excluded: false,
    isExpanded: true,
};
